import { render, staticRenderFns } from "./pdf-by-grade.vue?vue&type=template&id=8432fab6&scoped=true&"
import script from "./pdf-by-grade.vue?vue&type=script&lang=js&"
export * from "./pdf-by-grade.vue?vue&type=script&lang=js&"
import style0 from "./pdf-by-grade.vue?vue&type=style&index=0&id=8432fab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8432fab6",
  null
  
)

export default component.exports